
import { Options, Prop, Vue, Watch } from 'vue-property-decorator';
import { HumanEpisode } from '@/api';
import { websocketModule } from '@/store/ws/websocket.module';
import { isDefined } from '@/common/utils';
import EventItemFull from '@/components/events/EventItemFull.vue';
import EventsPage from '@/pages/events/EventsPage.vue';
import type { CameraId, Nullable } from '../../types';
import { fetchHumanEpisodes } from '../../utils';

@Options({
  components: { EventItemFull, EventsPage }
})
export default class VideoWallEpisodeList extends Vue {
  @Prop({ required: true })
  readonly tab: string = '';

  @Prop({ required: true, type: Array })
  readonly cameraIds!: CameraId[];

  get filters() {
    return { cameras: this.cameraIds };
  }
}
